/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContactPerson } from '../models/work-contact-person';
import { WorkCreateContactPersonDto } from '../models/work-create-contact-person-dto';
import { WorkUpdateContactPersonDto } from '../models/work-update-contact-person-dto';

@Injectable({ providedIn: 'root' })
export class WorkContactPersonsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactPersonsV2ControllerFindAllByContactId()` */
  static readonly ContactPersonsV2ControllerFindAllByContactIdPath = '/v2/contact-persons/by-contact/{contactId}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPersonsV2ControllerFindAllByContactId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerFindAllByContactId$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContactPerson>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactPersonsV2Service.ContactPersonsV2ControllerFindAllByContactIdPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContactPerson>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPersonsV2ControllerFindAllByContactId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerFindAllByContactId(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkContactPerson>> {
    return this.contactPersonsV2ControllerFindAllByContactId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContactPerson>>): Array<WorkContactPerson> => r.body)
    );
  }

  /** Path part for operation `contactPersonsV2ControllerSearch()` */
  static readonly ContactPersonsV2ControllerSearchPath = '/v2/contact-persons/search';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPersonsV2ControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerSearch$Response(
    params: {
      query: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContactPerson>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactPersonsV2Service.ContactPersonsV2ControllerSearchPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContactPerson>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPersonsV2ControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerSearch(
    params: {
      query: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkContactPerson>> {
    return this.contactPersonsV2ControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContactPerson>>): Array<WorkContactPerson> => r.body)
    );
  }

  /** Path part for operation `contactPersonsV2ControllerFindOne()` */
  static readonly ContactPersonsV2ControllerFindOnePath = '/v2/contact-persons/{id}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPersonsV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactPerson>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactPersonsV2Service.ContactPersonsV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactPerson>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPersonsV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkContactPerson> {
    return this.contactPersonsV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactPerson>): WorkContactPerson => r.body)
    );
  }

  /** Path part for operation `contactPersonsV2ControllerDelete()` */
  static readonly ContactPersonsV2ControllerDeletePath = '/v2/contact-persons/{id}';

  /**
   * Required permissions: contacts:delete, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPersonsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactPersonsV2Service.ContactPersonsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: contacts:delete, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPersonsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactPersonsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.contactPersonsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `contactPersonsV2ControllerUpdate()` */
  static readonly ContactPersonsV2ControllerUpdatePath = '/v2/contact-persons/{id}';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPersonsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactPersonsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateContactPersonDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactPerson>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactPersonsV2Service.ContactPersonsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactPerson>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPersonsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactPersonsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateContactPersonDto
    },
    context?: HttpContext
  ): Observable<WorkContactPerson> {
    return this.contactPersonsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactPerson>): WorkContactPerson => r.body)
    );
  }

  /** Path part for operation `contactPersonsV2ControllerCreate()` */
  static readonly ContactPersonsV2ControllerCreatePath = '/v2/contact-persons';

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactPersonsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactPersonsV2ControllerCreate$Response(
    params: {
      body: WorkCreateContactPersonDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactPerson>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactPersonsV2Service.ContactPersonsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactPerson>;
      })
    );
  }

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactPersonsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactPersonsV2ControllerCreate(
    params: {
      body: WorkCreateContactPersonDto
    },
    context?: HttpContext
  ): Observable<WorkContactPerson> {
    return this.contactPersonsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactPerson>): WorkContactPerson => r.body)
    );
  }

}
